import { render, staticRenderFns } from "./LandingBirthdayNL.vue?vue&type=template&id=239476f9"
import script from "./LandingBirthdayNL.vue?vue&type=script&lang=js"
export * from "./LandingBirthdayNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports